// extracted by mini-css-extract-plugin
export default {"accountantsGrid":"AccountantsView_accountantsGrid__6tA8k","showMoreWrapper":"AccountantsView_showMoreWrapper__BnOnm"};